export const base_api_url = process.env.REACT_APP_BASE_API_URL + "/Admin/";
export const base_api_audit_url = process.env.REACT_APP_BASE_API_URL + "/Admin/Audit";
export const ckEditorUploadUrl = process.env.REACT_APP_BASE_API_URL + "/admin/audit/New/CkEditor";
export const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;



// WEBPACK FOOTER //
// ./src/config.js